module.exports = (window.PropTypes || window.React.PropTypes);